import { customerPhoneStringToInputValue } from "@jugl-web/ui-kit";
import { humanizeCustomerPhoneNumber } from "@jugl-web/utils/utils/humanizeCustomerPhoneNumber";

/**
 * Converts a customer phone string to a human-readable display format.
 * Accepts multiple formats:
 * - NEW: "911234567890" (concatenated, no plus)
 * - OLD: "IN,+91,1234567890" (comma-separated)
 * - EXTRA: "+911234567890" (with plus sign)
 *
 * @param phoneStr - Phone number string in any supported format
 * @returns Internationalized phone number string (e.g., "+91 12345 67890")
 */
export const customerPhoneStringToDisplay = (
  phoneStr?: string | null
): string => {
  if (!phoneStr) {
    return "";
  }

  // Parse the phone string (handles all formats)
  const { code, phone } = customerPhoneStringToInputValue(phoneStr);

  if (!code || !phone) {
    return phoneStr; // Return as-is if parsing failed
  }

  // Reconstruct and format using humanizeCustomerPhoneNumber
  const phoneNumberString = `${code}${phone}`;
  return humanizeCustomerPhoneNumber(phoneNumberString);
};
